import axios from 'axios';
import React from 'react';
import PropTypes from 'prop-types';
import { I18nextProvider } from 'react-i18next';

import { notifyViewStartLoading } from '@wix/business-manager-api';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import { COMPONENT_NAME } from './config';
import i18n from './i18n';
import App from './components/App';

import { createLogger } from './biLogger';

wixAxiosConfig(axios, {
  baseURL: '/',
});

export default class AppContainer extends React.Component {
  static propTypes = {
    accountLanguage: PropTypes.string,
    config: PropTypes.object,
  };

  constructor(props) {
    super(props);
    notifyViewStartLoading(COMPONENT_NAME);
    this.biLogger = createLogger({
      msid: props.metaSiteId,
      uuid: props.userId,
    });
  }

  render() {
    const {
      accountLanguage: locale,
      config: {
        topology: { staticsUrl: baseUrl, wixOnWixUrl },
      },
      userRole,
    } = this.props;

    const localeFile = `${baseUrl}/assets/locale/messages_${locale}.json`;
    const metaSiteId = this.props.metaSiteId;

    const config = {
      locale,
      localeFile,
      wixOnWixUrl,
      userRole,
      metaSiteId,
    };
    return (
      <I18nextProvider i18n={i18n(locale, baseUrl)}>
        <App config={config} biLogger={this.biLogger} />
      </I18nextProvider>
    );
  }
}
